export const formatLastUpdatedDate = (dateInput?: string | Date): string => {
  try {
    if (!dateInput) {
      return getCurrentMonthYear();
    }
    
    const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
    
    if (isNaN(date.getTime())) {
      console.warn('Invalid date provided, using current date as fallback:', dateInput);
      return getCurrentMonthYear();
    }
    
    return date.toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric'
    });
  } catch (error) {
    console.error('Error formatting date:', error, { dateInput });
    return getCurrentMonthYear();
  }
};

const getCurrentMonthYear = (): string => {
  return new Date().toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric'
  });
};